import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './layouts/Layout';
import Login from './pages/Auth/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Delegates from './pages/Delegates/Delegates';
import Profile from './pages/Profile/Profile';
import ChangePassword from './pages/Profile/ChangePassword';
import NotFound from './pages/Page404';
import AccountTwoFactorAuth from './pages/Profile/AccountTwoFactorAuth';

// ----------------------------------------------------------------------

const Authentication = () => {
  if (localStorage.getItem('token')) {
    return <Navigate to="/dashboard" />;
  }
  return <Navigate to="/login" />;
};
const RouteGaurd = ({ children }) => {
  if (localStorage.getItem('token')) {
    return <Navigate to="/dashboard" />;
  }
  return children;
};

export default function Router() {
  return (
    <Routes>
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<Authentication />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/coaches" element={<Delegates />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/two-factor-authentication" element={<AccountTwoFactorAuth />} />
      </Route>
      <Route>
        <Route path="/login" element={<RouteGaurd>
          <Login />
        </RouteGaurd>} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}